export const LIST_PER_PAGE = 10
export const SCROLL_DEBOUNCE_TIME = 2000
